import React from 'react';
import { Col, Button, Typography } from 'antd';
import i18n from 'i18next';

export interface ModalSuccessContentProps {
  icon: string;
  message: string;
  onClick?: (e?: React.MouseEvent) => void;
}

export const ModalSuccess: React.FC<ModalSuccessContentProps> = ({
  icon,
  message,
  onClick,
}) => {
  return (
    <div>
      <Col span={24} className="modal-email-sent">
        <img src={icon} alt="email-sent" />
      </Col>
      <Col span={24} className="success-text">
        <Typography.Text>{message}</Typography.Text>
      </Col>
      <Col span={24} className="report-button">
        <Button type="default" onClick={onClick} className="send-report-button">
          <span>{i18n.t('Continue')}</span>
        </Button>
      </Col>
    </div>
  );
};
